import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { PrimengImports } from '../../../shared/primeng-imports';
import { InvestmentConsultationRequest, InvestmentConsultationService } from '../../../service/investment-consultation.service';
import { FooterComponent } from "../footer/footer.component";
import { UserLoginComponent } from "../../auth/user-login/user-login.component";
import { PortfolioService } from '../../../service/portfolio.service';
import { InvestmentDialogComponent } from '../investment-dialog/investment-dialog.component';
import { ImageUrlPipe } from '../../../pipes/image-url.pipe';
import { MessageService } from 'primeng/api';
import { InputPatternDirective } from '../../../directives/input-pattern.directive';
import { ActivatedRoute } from '@angular/router';


export interface Testimonial {
  name: string;
  role: string;
  image: string;
  content: string;
  rating: number;
}
export interface TimeHorizonOption {
  Months: number;
  label: string;
}
export interface CalculationResult {
  projectedValue: number;
  initialInvestment: number;
  investmentPeriod: number;
  expectedROI: string;
  potentialProfit: number;
}
interface Office {
  country: string;
  city: string;
  address: string;
  phone: string;
  email: string;
}

interface ConsultationForm {
  name: string;
  email: string;
  phone: string;
  preferredOffice: string;
  description: string;
}
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, LucideIconsModule, PrimengImports, FooterComponent, InvestmentDialogComponent, ImageUrlPipe, UserLoginComponent, ReactiveFormsModule, InputPatternDirective],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  providers:[MessageService]
})

export class HomeComponent  implements OnInit {
[x: string]: any;

  investmentProducts: any[] = [];
  portfoliosLoading = false;
  portfoliosError = '';
  showInvestmentDialog: boolean = false;
  selectedPortfolio: any = null;
  cities = [
    { name: 'UAE - Abu Dhabi', code: 'uae' },
    { name: 'UK - London', code: 'uk' },
    { name: 'Luxembourg', code: 'luxembourg' },
    { name: 'Switzerland - Zurich', code: 'switzerland' },
  ];
    loginMode: 'login' | 'signup' = 'login';

private _showLoginModal = false;
  get showLoginModal() {
    return this._showLoginModal;
  }
  set showLoginModal(val: boolean) {
    this._showLoginModal = val;  
    if (val) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
  constructor(
    private investmentConsultationService: InvestmentConsultationService,
    private portfolioService: PortfolioService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    console.log("environment amplify", )
    this.fetchPortfolios();
    this.buildConsultForm();
    this.route.queryParamMap.subscribe(params => {
      if (params.get('action') === 'login') {
        this.openLogin('login');
        if (params.get('verified') === 'true') {
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Email Verified', 
            detail: 'Your email has been successfully verified. Please log in to continue.', 
            life: 5000 
          });
        }
      }
    });
  }

  private fetchPortfolios(): void {
    this.portfoliosLoading = true;
    this.portfoliosError = '';
    this.portfolioService.fetchPortfolios().subscribe({
      next: (response) => {
        this.investmentProducts = response.data;
       
       
        this.portfoliosLoading = false;
      },
      error: (err) => {
        this.portfoliosError = err?.message || 'Failed to load portfolios.';
        this.portfoliosLoading = false;
      }
    });
  }

  private getPortfolioIcon(name: string): string {
    // Map portfolio name to icon (fallback to 'briefcase')
    if (name.toLowerCase().includes('real estate')) return 'building-2';
    if (name.toLowerCase().includes('energy') || name.toLowerCase().includes('lng')) return 'zap';
    if (name.toLowerCase().includes('ai') || name.toLowerCase().includes('artificial intelligence')) return 'cpu';
    if (name.toLowerCase().includes('agriculture')) return 'wheat';
    return 'briefcase';
  }
 scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
   onInvestNow(product: any): void {
    this.selectedPortfolio = product;
    this.showInvestmentDialog = true;
    console.log("product",product)
  }

  onInvestmentDialogClose() {
    this.showInvestmentDialog = false;
    this.selectedPortfolio = null;
  }

  onBuyTickets(event: { portfolio: any, tickets: number }) {
    alert(`Successfully bought ${event.tickets} ticket(s) for ${event.portfolio.title}!`);
    this.onInvestmentDialogClose();
  }
    testimonials: Testimonial[] = [
    {
      name: "Ahmed Al-Rashid",
      role: "Real Estate Developer",
      image: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400",
      content: "Hector Global's Real Estate portfolio delivered exceptional returns. My 500,000 AED investment has grown tremendously over 5 Months.",
      rating: 5
    },
    {
      name: "Sarah Mitchell",
      role: "Tech Entrepreneur",
      image: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400",
      content: "The AI investment opportunities through Hector Global have been revolutionary. Outstanding performance and professional service.",
      rating: 5
    },
    {
      name: "Marcus Weber",
      role: "Energy Consultant",
      image: "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=400",
      content: "Clean Energy (LNG) investments with Hector Global have exceeded all expectations. Truly a global leader in sustainable investing.",
      rating: 5
    },
    {
      name: "Elena Rossi",
      role: "Agricultural Investor",
      image: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=400",
      content: "The agriculture portfolio has been incredibly profitable. Hector Global's expertise in emerging markets is unmatched.",
      rating: 5
    }
  ];

  // Helper method to generate array for star ratings
  getStarsArray(rating: number): number[] {
    return Array(rating).fill(0).map((_, i) => i);
  }

  investmentAmount: number = 100000;
  timeHorizon: number = 2;

  timeHorizonOptions: TimeHorizonOption[] = [
    { Months: 1, label: '1 Year' },
    { Months: 2, label: '2 Years' },
    { Months: 3, label: '3 Years' },
    { Months: 5, label: '5 Years' }
  ];

  onInvestmentAmountChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.investmentAmount = Number(target.value);
  }

  onTimeHorizonChange(Months: number): void {
    this.timeHorizon = Months;
  }

  calculateReturns(): number {
    let annualReturn = 0.24; // Default 24% for 1 year
    if (this.timeHorizon >= 5) annualReturn = 1.0; // 100% for 5 Months
    else if (this.timeHorizon >= 3) annualReturn = 0.5; // 50% for 3 Months
    else if (this.timeHorizon >= 2) annualReturn = 0.36; // 36% for 2 Months
    
    const futureValue = this.investmentAmount * (1 + annualReturn);
    return Math.round(futureValue);
  }

  getExpectedROI(): string {
    if (this.timeHorizon >= 5) return 'Up to 100%';
    if (this.timeHorizon >= 3) return 'Up to 50%';
    if (this.timeHorizon >= 2) return 'Up to 36%';
    return 'Up to 24%';
  }

  getPotentialProfit(): number {
    return this.calculateReturns() - this.investmentAmount;
  }

  getCalculationResult(): CalculationResult {
    return {
      projectedValue: this.calculateReturns(),
      initialInvestment: this.investmentAmount,
      investmentPeriod: this.timeHorizon,
      expectedROI: this.getExpectedROI(),
      potentialProfit: this.getPotentialProfit()
    };
  }

  formatNumber(num: number): string {
    return num.toLocaleString();
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  formatMonthsToYears(months: number): string {
    if (!months) return '';
    
    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;
    
    if (years === 0) {
      return `${months} month${months !== 1 ? 's' : ''}`;
    } else if (remainingMonths === 0) {
      return `${years} year${years !== 1 ? 's' : ''}`;
    } else {
      return `${years} year${years !== 1 ? 's' : ''} ${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`;
    }
  }
  openLogin(mode: 'login' | 'signup' = 'login') {
    this.loginMode = mode;
    this.showLoginModal = true;
  }
    handleClose() {
    this.showLoginModal = false;
  }
    handleLogin(user: any) {
    this.showLoginModal = false;
    // handle user login logic if needed
  }
  isTimeHorizonSelected(Months: number): boolean {
    return this.timeHorizon === Months;
  }
 // Office data
  offices: Office[] = [
    {
      country: "UAE",
      city: "Abu Dhabi",
      address: "519, 5th Floor, Hanging Garden Tower, Hamdan Street",
      phone: "+971 542 454 555",
      email: "info@hector-ae.com"
    },
    {
      country: "United Kingdom",
      city: "London",
      address: "25 Old Broad Street, London EC2N 1HN",
      phone: "+44 20 7946 0958",
      email: "info@hector-uk.com"
    },
    {
      country: "Luxembourg",
      city: "Luxembourg City",
      address: "12 Rue Erasme, L-1468 Luxembourg",
      phone: "+352 26 19 15 20",
      email: "info@hector-lu.com"
    },
    {
      country: "Switzerland",
      city: "Zurich",
      address: "Bahnhofstrasse 45, 8001 Zürich",
      phone: "+41 44 224 15 15",
      email: "info@hector-ch.com"
    }
  ];

  // Reactive form state
  consultForm!: FormGroup;
  submitted = false;

  // Loading and message states
  consultLoading = false;
  wordCount = 0;

  // Word counting for description field
  onDescriptionInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    const text = target.value.trim();
    this.wordCount = text ? text.split(/\s+/).length : 0;
  }
  // consultSuccess = '';
  // consultError = '';

  // Form submission handler (Reactive Forms)
  onConsultationSubmit(): void {
    this.submitted = true;

    // Check word count limit
    if (this.wordCount > 60) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Word Limit Exceeded',
        detail: 'Please limit your description to 60 words maximum.',
        life: 3000
      });
      return;
    }

    if (!this.consultForm || this.consultForm.invalid) {
      this.consultForm?.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please fix the highlighted fields before submitting.',
        life: 2500
      });
      return;
    }
    this.consultLoading = true;

    // Keep payload structure identical
    const formValue = this.consultForm.value;
    const request: any = {
      name: formValue.name,
      email: formValue.email,
      phone: formValue.phone,
      preferredOffice: formValue.preferredOffice,
      description: formValue.description
    };

    this.investmentConsultationService.submitConsultation(request).subscribe({
      next: (res: any) => {
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: res.message || 'Your request has been submitted successfully!', 
          life: 3000 
        });
        this.resetForm();
        this.consultLoading = false;
      },
      error: (error) => {
        const errorMessage = error?.error?.message || 'Submission failed. Please try again.';
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: errorMessage, 
          life: 3000 
        });
        this.consultLoading = false;
      }
    });
  }


  // Initialize reactive form
  private buildConsultForm(): void {
    const alphaSpaces = /^[A-Za-z ]+$/;
    const mobile8to15 = /^[0-9]{8,15}$/;
    this.consultForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.pattern(alphaSpaces)]],
      email: ['', [Validators.required, Validators.email]],
      preferredOffice: ['', [Validators.required]],
      phone: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(8), Validators.maxLength(15), Validators.pattern(mobile8to15)]],
      description: ['', [Validators.required, Validators.minLength(3)]]
    });

    // Enable/disable phone based on preferredOffice
    this.consultForm.get('preferredOffice')!.valueChanges.subscribe((val) => {
      const phoneCtrl = this.consultForm.get('phone')!;
      if (val) {
        phoneCtrl.enable({ emitEvent: false });
      } else {
        phoneCtrl.disable({ emitEvent: false });
        phoneCtrl.reset('', { emitEvent: false });
      }
    });
  }

  // Reset form helper
  private resetForm(): void {
    if (this.consultForm) {
      this.consultForm.reset();
      // Restore disabled state for phone until city selected again
      this.consultForm.get('phone')?.disable({ emitEvent: false });
    }
    this.submitted = false;
    this.wordCount = 0;
  }


}
